module.exports = __webpack_public_path__ + "static/media/video.2a8aa469.svg";